/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import {connect} from 'react-redux';
import {defineMessages, FormattedMessage, injectIntl, intlShape} from 'react-intl';
import {compose} from 'redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from "./Header.css";
import f from '../../style/foundation.min.css';
import Link from '../Link';
import Navigation from '../Navigation';
import LanguageSwitcher from '../LanguageSwitcher';
import icon from '../../fonts/ionicons.min.css';
import ScrollToTopButton from './components/Scroll-to-top/Scroll-to-top';
import Logo from './components/Logo/Logo';
/*eslint-enable no-unused-vars*/
import {  LgScreen, LgScreenHidden  } from 'react-responsive-redux';
import Input from '../Form/Input/Input';
import Close from '../../components/Button/Button-close/Button-close';
import {modalZ} from './components/Scripts/modalZ.js';
import axios from 'axios';

const messages = defineMessages({
    title: {
      id: 'header.modalTitle',
      defaultMessage: 'Request a call',
      description: 'Title for modal',
  },
    name: {
      id: 'header.modalName',
      defaultMessage: 'React',
      description: 'Title in page header',
  },
    phone: {
      id: 'header.modalPhone',
      defaultMessage: 'Complex web apps made easy',
      description: 'Description in header',
  },
    send: {
        id: 'header.modalSend',
        defaultMessage: 'Complex web apps made easy',
        description: 'Description in header',
    },
    headerSuccess1: {
        id: 'header.headerSuccess1',
        defaultMessage: 'Thank you',
    },
    headerSuccess2: {
        id: 'header.headerSuccess2',
        defaultMessage: 'Your message has been sent',
    },
    headerErr: {
        id: 'header.headerErr',
        defaultMessage: 'There was an error sending the message',
    }
});


class Header extends React.Component {
    constructor() {
        super();

        this.state = {
            name: '',
            phone: ''
        }

        this.handelNameChang = this.handelNameChang.bind(this);
        this.handelPhoneChang = this.handelPhoneChang.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        modalZ();
    }
    handelNameChang(event) {
        this.setState({name: event.target.value})
    }
    handelPhoneChang(event) {
        this.setState({phone: event.target.value})
    }

    resultCheng(event) {
        this.setState({result: <FormattedMessage {...messages[this.props.FORM.success1]} /> + this.state.name + <FormattedMessage {...messages[this.props.FORM.success2]} />})
    }


    handleSubmit(e){
        e.preventDefault();
            this.setState({
                name: '',
                phone: '',
                result: <FormattedMessage {...messages.headerSuccess1} />
            });
        axios({
            method: "POST",
            url:"/send-call-me",
            data: {
                name: this.state.name,
                phone: this.state.phone,
            }
        }).then((response)=>{
            if (response.data.msg === 'success'){
                this.setState({result: <FormattedMessage {...messages.headerSuccess2} />})
            }else if(response.data.msg === 'fail'){
                console.log("success");
                this.setState({result: <FormattedMessage {...messages.headerErr} />})
            }
        })
    }
    render() {
        return (
            <header id="header" className={['header-top'] + " " + ['hh-header'] + " " + ['hh-header'] + ' ' + s['header-top']}>
              <div id="headerTop">
                  <LgScreenHidden>
                <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="100%" height="60px" id="navflow">
                  <defs>
                    <linearGradient id="Gradient1">
                      <stop className="stop1" offset="5%" stopColor="#4648d0" />
                      <stop className="stop2" offset="35%" stopColor="#6d2ad6" />
                      <stop className="stop4" offset="65%" stopColor="#ab2dec" />
                      <stop className="stop5" offset="95%" stopColor="#e834ca" />
                    </linearGradient>
                  </defs>
                </svg>
              </LgScreenHidden>
              <LgScreen>
                  <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="100%" height="60px" id="navflow">
                      <defs>
                          <linearGradient id="Gradient1">
                              <stop className="stop1" offset="5%" stopColor="#4648d0" />
                              <stop className="stop2" offset="35%" stopColor="#6d2ad6" />
                              <stop className="stop4" offset="65%" stopColor="#ab2dec" />
                              <stop className="stop5" offset="95%" stopColor="#e834ca" />
                          </linearGradient>
                      </defs>
                      <path id="menuSvg" d="M0,20 C0,20 80,20 200,20 L200,0 L0,0 L0,20"  stroke="rgba(255,255,255,.2)" stroke-width="0" fill="url(#Gradient1)" />
                  </svg>
              </LgScreen>
                <div id="navTop" className={['root']}>
                  <span id="modalTopClick" className={s.contactTop}>+38(044)531-66-65</span>
                  <Navigation />
                  <div className={['logo-wrapper'] + " " + s['logo-wrapper']}>
                    <a href="#mainSlider">
                      <Logo />
                    </a>
                  </div>
                </div>
              </div>
              <LanguageSwitcher />
              {/*<Share />*/}
              <ScrollToTopButton
                  scrollStepInPx="50"
                  delayInMs="16.66"
              />
              <div id="modalTop" className={['container']}>
                <div className={['content']}>
                  <div id={['modalTopPhone']} className={s.dialog + " " + ['dialog']}>
                    <div className={s['dialog__overlay'] + " " + ['dialog__overlay']}></div>
                    <div className={s['dialog__content'] + " " + ['dialog__content']}>
                      <Close
                          className={s.btClose}
                      />
                      <h2><FormattedMessage {...messages.title} /></h2>
                      <form onSubmit={this.handleSubmit} method="POST" className={['form'] + " " + ['message'] + " " + s.subscribeForm + " " + ['send_message_form']} method="post" id={['subscribeForm']}>
                        <div className={f['medium-12'] + " " + f['large-12'] + " " + f['columns']}>
                          <Input
                              type={'text'}
                              inputText={<FormattedMessage {...messages.name} />}
                              inputClass={s.input}
                              value={this.state.name}
                              onChange={this.handelNameChang}
                          />
                        </div>
                        <div className={f['medium-12'] + " " + f['large-12'] + " " + f['columns']}>
                          <Input
                              type={'text'}
                              inputText={<FormattedMessage {...messages.phone} />}
                              inputClass={s.input}
                              value={this.state.phone}
                              onChange={this.handelPhoneChang}
                          />
                        </div>
                        <div className={f['large-12'] + " " + f['columns']}>
                          <button className={s.buttonSubscribe} type="submit" value="Submit">
                            <span className={s.title}><FormattedMessage {...messages.send} /></span>
                          </button>
                        </div>
                        <div id={s.loadBar}>{this.state.result}</div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </header>
        );
    }
}



export default injectIntl(
    compose(
        withStyles(s, f, icon),
        connect(
            state => ({
                FORM: state.dataRu.HEADER
            }),
            dispatch => ({})
        )
    )(Header));
